import React, { useEffect } from "react";
import bem from 'utils/bem';
import toast from 'react-hot-toast';
import { Formik } from 'formik';
import validationSchema from './validationSchema';
import Form from './Form';
import Model from '../../../../model';
import { buyCard, getAuth } from 'api/cards';
import './index.sass'

const initialValues = {
    customerPhone: '',
    customerName: '',
    customerSurname: '',
    customerEmail: '',
    customerEmailConfirmation: '',
    acceptConditions: false,
    mail: '',
    mailConfirmation: '',
    amount: '',
    card: '',
    customerFound: false,
};

const { block, el } = bem('payment-card-form');

const PaymentCardForm = ({price, cardId}) => {

    useEffect(() => {
        if (!price) {
            toast.error(`К сожалению, покупка в данный момент недоступна. Пожалуйста, обратитесь к администратору`)
        }
    }, [price])

    const handleSubmit = async (values, bag) => {

        const variables = {
            ...values,
            amount: price,
            card: cardId
        };

        try {
            const { error, purchaseId } = await buyCard(variables);
            Model.user.updateUserInfo();
            if (error) {
                throw error;
            }
            if (purchaseId) {
                const data = await getAuth({ purchaseId });
                console.log(data);
                Model.modal.closePaymentCardForm();
                window.halyk.showPaymentWidget(data, (params) => {
                    console.log(params);
                });
            } else {
                throw `received no purchase id`;
            }
        } catch (err) {
            console.log(err);
            toast.error(`Произошла ошибка: ${ err }`);
            bag.setSubmitting(false);
        }
    };

    return <div className={block()}>
        <Formik
            initialValues={initialValues}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}>
            {props => <Form {...props} price={price}/>}
        </Formik>
    </div>
};

export default PaymentCardForm;
